import { fetchJSON } from '../Tools';

export default class Pdf {
    protected btnPdf: NodeListOf<HTMLElement> = null;
    protected btnPrint: NodeListOf<HTMLElement> = null;
    constructor() {
        const _this = this;
        _this.btnPdf = document.querySelectorAll('.rw-action-pdf');
        _this.btnPrint = document.querySelectorAll('.rw-action-print');
        if (!_this.btnPdf.length) {
            return;
        }
        _this.btnPdf.forEach((btn) => {
            btn.addEventListener('click', () => {
                window.open('/?ajax=RWPdf&rw=' + btn.dataset.rw);
            });
        });
        _this.btnPrint.forEach((btn) => {
            btn.addEventListener('click', () => {
                window.open('/?ajax=RWPdf&html&rw=' + btn.dataset.rw);
            });
        });
    }
}
